import { Fragment } from 'react';

import ItemHeader from '@components/productDetail/ItemHeader';

import css from '@styles/productDetail';

import type { TBandDetail } from '@types/band';

export default function DescriptionAndPrice({ band }: { band: TBandDetail }) {
  return (
    <Fragment>
      <ItemHeader
        title={band.short_description}
        price={band.retail_price}
        bank_wire={band.bank_wire_price}
        noCapitalize
      />
    </Fragment>
  );
}
